import React, { PropsWithChildren, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import LinearProgress from '@mui/material/LinearProgress';
import CloudOffIcon from '@mui/icons-material/CloudOff';

const OnlineCheck = ({ children }: PropsWithChildren<unknown>) => {
	const { t } = useTranslation('errors');

	const [isOnline, setIsOnline] = useState(true);
	const handleCheck = () => {
		setIsOnline(navigator.onLine);
	};

	useEffect(() => {
		window.addEventListener('online', handleCheck);
		window.addEventListener('offline', handleCheck);

		return () => {
			window.removeEventListener('online', handleCheck);
			window.removeEventListener('offline', handleCheck);
		};
	}, []);

	return (
		<>
			<Dialog open={!isOnline}>
				<DialogTitle sx={{}}>
					<CloudOffIcon
						sx={{
							verticalAlign: 'bottom',
							paddingBottom: '.1em',
							marginRight: '.5em',
							fontSize: '150%',
						}}
					/>
					{t('offline_title')}
				</DialogTitle>
				<DialogContent>
					<DialogContentText
					// sx={{
					// 	display: 'flex',
					// 	flexDirection: 'column',
					// 	alignItems: 'center',
					// }}
					>
						{t('offline_description')}
						<br />
					</DialogContentText>
				</DialogContent>
				<LinearProgress />
			</Dialog>

			{children}
		</>
	);
};

export default OnlineCheck;
